<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("heading.trips") }}</v-toolbar-title>
      <v-spacer />
      <v-btn :to="{ name: 'create-trip' }" large class="primary">
        <v-icon left>mdi-plus</v-icon>
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="trips"
      resName="trips"
      class="table-row"
      :imagePath="imagePath"
      :overlay.sync="overlay"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">
          <v-avatar @click="showImage(item)" size="40">
            <img
              :src="item.main_media ? item.main_media.path : dummyIcon"
              alt="Icon"
            />
          </v-avatar>
        </td>
        <td class="text-sm-center">{{ item.name }}</td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="trips"
            :model-id="item.id"
            field="premium"
            v-model="item.premium"
            :validate="true"
          />
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="trips"
            :model-id="item.id"
            field="auto_accept_order"
            v-model="item.auto_accept_order"
            :validate="true"
          />
        </td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="trips"
            :model-id="item.id"
            field="allow_custom_dates"
            v-model="item.allow_custom_dates"
            :validate="true"
          />
        </td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="trips"
            :model-id="item.id"
            field="available"
            v-model="item.available"
            :validate="true"
          />
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="trips"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>

        <td class="text-sm-center">
          <v-btn icon color="info" :to="`/trips/edit/${item.slug}`">
            <v-icon :title="$t('icon.edit')" small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon
              color="error"
              @click="handleDelete(item, index)"
              :title="$t('icon.delete')"
              small
              >mdi-delete</v-icon
            >
          </v-btn>
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
  </main>
</template>

<script>
export default {
  name: "Trips",
  data() {
    return {
      overlay: false,
      imagePath: "",
      dummyIcon: "https://via.placeholder.com/50x50?text=icon",

      headers: [
        "photo",
        "name",
        "premium",
        "auto_accept_order",
        "allow_custom_dates",
        "available",
        "visible",
        "actions"
      ]
    };
  },
  methods: {
    showImage({ main_media }) {
      this.imagePath = main_media.path;
      this.overlay = true;
    },
    handleDelete({ slug }, index) {
      this.$refs.table_ref.handleDelete(slug, index);
    }
  }
};
</script>
